import _once from "lodash/once.js";
function cov_27bw0i6wa5() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/growth/AddressInput/ensureGoogleMaps.ts";
  var hash = "56f3a0a75da1276c223dd72cb10853200df3e902";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/growth/AddressInput/ensureGoogleMaps.ts",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "1": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 27,
          column: 6
        }
      },
      "2": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 17,
          column: 7
        }
      },
      "3": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 18
        }
      },
      "4": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 21,
          column: 8
        }
      },
      "5": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 18
        }
      },
      "6": {
        start: {
          line: 22,
          column: 21
        },
        end: {
          line: 22,
          column: 53
        }
      },
      "7": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 38
        }
      },
      "8": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 26
        }
      },
      "9": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 153
        }
      },
      "10": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 67
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 27,
            column: 6
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 13,
            column: 22
          },
          end: {
            line: 13,
            column: 23
          }
        },
        loc: {
          start: {
            line: 13,
            column: 35
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 19,
            column: 41
          },
          end: {
            line: 19,
            column: 42
          }
        },
        loc: {
          start: {
            line: 19,
            column: 47
          },
          end: {
            line: 21,
            column: 7
          }
        },
        line: 19
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 17,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 17,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 15,
            column: 10
          },
          end: {
            line: 15,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 10
          },
          end: {
            line: 15,
            column: 32
          }
        }, {
          start: {
            line: 15,
            column: 36
          },
          end: {
            line: 15,
            column: 63
          }
        }],
        line: 15
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "56f3a0a75da1276c223dd72cb10853200df3e902"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_27bw0i6wa5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_27bw0i6wa5();
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
// NOTE: Given how 'once' works, it ignore arguments to de-dupe future calls, so we'll end up using the
// very first instance of ensureGoogle(key) that gets called with that key, and ignore any subsequent
// load calls with a different key if they get loaded in the same context (they will all share the same
// google instance). This is because google api only likes having a single instance of it loaded on the page.

// Google API calls use this project for billing and API keys:
// https://console.cloud.google.com/apis/credentials?project=val-tool-3-1495755979574&organizationId=727186813944

var ensureGoogle = (cov_27bw0i6wa5().s[0]++, _once(function (googleMapsApiKey) {
  cov_27bw0i6wa5().f[0]++;
  cov_27bw0i6wa5().s[1]++;
  return new Promise(function (resolve) {
    cov_27bw0i6wa5().f[1]++;
    cov_27bw0i6wa5().s[2]++;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((cov_27bw0i6wa5().b[1][0]++, window.google) && (cov_27bw0i6wa5().b[1][1]++, window.google.maps)) {
      cov_27bw0i6wa5().b[0][0]++;
      cov_27bw0i6wa5().s[3]++;
      resolve();
    } else {
      cov_27bw0i6wa5().b[0][1]++;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cov_27bw0i6wa5().s[4]++;
    window.onGoogleMapsLoad = function () {
      cov_27bw0i6wa5().f[2]++;
      cov_27bw0i6wa5().s[5]++;
      resolve();
    };
    var script = (cov_27bw0i6wa5().s[6]++, document.createElement('script'));
    cov_27bw0i6wa5().s[7]++;
    script.type = 'text/javascript';
    cov_27bw0i6wa5().s[8]++;
    script.async = true;
    cov_27bw0i6wa5().s[9]++;
    script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(googleMapsApiKey, "&v=3.exp&libraries=geometry,drawing,places&callback=onGoogleMapsLoad");
    cov_27bw0i6wa5().s[10]++;
    document.getElementsByTagName('head')[0].appendChild(script);
  });
}));
export default ensureGoogle;
//# sourceMappingURL=ensureGoogleMaps.mjs.map